import React from 'react';
import styles from './HelpCenter.module.css';

const HelpCenter = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>Help Center</h1>
        </div>

        {/* Main Message */}
        <div className={styles.messageBox}>
          <div className={styles.icon}>📖</div>
          <h2 className={styles.messageTitle}>Coming Soon</h2>
          <p className={styles.messageText}>
            We're currently building our help center to better assist you. 
            This page will be published soon.
          </p>
        </div>

      </div>
    </div>
  );
};

export default HelpCenter;